module.exports = __webpack_public_path__ + "static/holubova-c02d8a7fe6ae52ccf053815ca18cb438.jpg";